import styles from './SectionTitle.module.scss';
import clsx from 'clsx';
import Typography from '~/shared/components/Typography/Typography';

type Props = {
    children: React.ReactNode;
    className?: string;
};

export const SectionTitle: React.FC<Props> = ({ children, className }) => {
    return (
        <Typography
            as="h2"
            variant="title-XS"
            weight="bold"
            className={clsx(styles.sectionTitle, className)}
        >
            {children}
        </Typography>
    );
};

export default SectionTitle;
